export const environment = {
  production: false,
  isMaintenance: false
};